module.exports = {"630102001":"东关大街社区公共服务中心","630102002":"清真巷社区公共服务中心","630102003":"大众街社区公共服务中心","630102004":"周家泉社区公共服务中心","630102005":"火车站社区公共服务中心","630102006":"康乐社区公共服务中心","630102007":"林家崖社区公共服务中心","630102008":"国际村社区公共服务中心","630102009":"富强巷社区公共服务中心","630102010":"青藏花园社区公共服务中心","630102011":"泰宁社区公共服务中心","630102012":"互助中路社区公共服务中心","630102100":"乐家湾镇政府","630102101":"韵家口镇政府"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630102.json
// module id = 2979
// module chunks = 0